export default "<div *ngIf=\"title\" class=\"chart__title chart__title--sankey\">{{ title }}</div>\n<div class=\"chart__wrap chart__wrap--sankey\"></div>\n";